/**
 * tab.ts
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { registerPlugins } from '#plugins/index.js'

// Components
import TabVue from './views/tab/tab.vue'

// Composables
import { createApp } from 'vue'

// Styles
import 'unfonts.css'

import { store } from '#stores/tab.js'

async function goApp() {
    const app = createApp(TabVue)
    registerPlugins(app, 'tab')
    await store.dbinit()
    app.mount('#app')
}

goApp()
